import { Component, EventEmitter, Input, Output, OnInit, HostListener, AfterViewInit, OnChanges } from '@angular/core';

@Component({
  selector: 'app-category-slider',
  templateUrl: './category-slider.component.html',
  styleUrls: ['./category-slider.component.scss'],
})
export class CategorySliderComponent implements OnInit, AfterViewInit, OnChanges {
  @Output() onCategorySelection: EventEmitter<any> = new EventEmitter();
  @Input() categoryData: any[] = [];
  @Input() currentIndex = 0;
  activeIndex = 0;
  imageItemWidth: string = '200px';
  imageContainerHeight: string = '300px';

  // Reference sizes
  private readonly referenceWidth = 2285;
  private readonly referenceHeight = 1100;
  private readonly referenceImageItemWidth = 400;
  private readonly referenceImageContainerHeight = 540;

  // Minimum sizes
  private readonly minImageItemWidth = 200;
  private readonly minImageContainerHeight = 300;

  ngOnInit(): void {
    this.activeIndex = this.currentIndex;
    this.adjustDimensions(window.innerWidth, window.innerHeight);
  }

  ngOnChanges(changes: any): void {
    if (changes['currentIndex'] && !changes['currentIndex'].firstChange) {
      this.activeIndex = this.currentIndex;
    }
  }

  ngAfterViewInit(): void {
    this.activeIndex = this.currentIndex;
    // Recalculate after view initialization to ensure accurate DOM measurements
    setTimeout(() => {
      this.adjustDimensions(window.innerWidth, window.innerHeight);
    });
  }

  trackByItems(index: number, item: any) {
    return item.id ?? item.name;
  }

  makeActive(i: number) {
    if (i === this.activeIndex) {
      this.onCategorySelection.emit(this.activeIndex);
      // this.onCategorySelection.emit(this.categoryData[this.activeIndex].id);
    } else {
      this.activeIndex = i;
      this.onCategorySelection.emit(this.activeIndex);
    }
  }

  getPosition(index: number) {
    const positionFromActiveIndex = index - this.activeIndex;
    return positionFromActiveIndex >= 0 ? positionFromActiveIndex : this.categoryData.length + positionFromActiveIndex;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.adjustDimensions(event.target.innerWidth, event.target.innerHeight);
  }

  @HostListener('window:load', ['$event'])
  onLoad(event: any) {
    this.adjustDimensions(window.innerWidth, window.innerHeight);
  }

  adjustDimensions(width: number, height: number) {
    // Calculate ratios
    const widthRatio = width / this.referenceWidth;
    const heightRatio = height / this.referenceHeight;

    // Use the smaller ratio to ensure fitting within the screen
    const scalingFactor = Math.min(widthRatio, heightRatio);

    // Calculate new dimensions
    let newImageItemWidth = this.referenceImageItemWidth * scalingFactor;
    let newImageContainerHeight = this.referenceImageContainerHeight * scalingFactor;

    // Ensure minimum sizes
    newImageItemWidth = Math.max(newImageItemWidth, this.minImageItemWidth);
    newImageContainerHeight = Math.max(newImageContainerHeight, this.minImageContainerHeight);

    // Apply new dimensions
    this.imageItemWidth = `${Math.round(newImageItemWidth)}px`;
    this.imageContainerHeight = `${Math.round(newImageContainerHeight)}px`;
  }
}
